// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 744 ? "actioncable" : chunkId) + "-" + {"702":"1c6dd58b459c7d85e585","744":"010bb279472874980001","856":"2862af26d3c1fce0d0ce"}[chunkId] + ".chunk.js";
};